import { Loader } from "@circle-react-uikit/Loader";
import { PdfPreview } from "@circle-react/components/shared/AttachmentPreview/PdfPreview";
import { contentTypeParser } from "@circle-react/components/shared/uikit/TipTap/utilities/contentTypeParser";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useState } from "react";

import { HtmlVideoPlayer } from "../../shared/uikit/VideoPlayer/HtmlVideoPlayer";
import type { AttachmentGalleryItem } from "./types";

interface AttachmentItemProps {
  attachment: AttachmentGalleryItem;
  isActive: boolean;
}

export const AttachmentItem = ({
  attachment,
  isActive,
}: AttachmentItemProps) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const isAttachmentPdf = contentTypeParser.isPDF(attachment.content_type);
  const isAttachmentImage = contentTypeParser.isImage(attachment.content_type);
  const isAttachmentVoiceMessage = Boolean(attachment.metadata?.voice_message);
  const isAttachmentVideo = contentTypeParser.isNativelySupportedVideo(
    attachment.content_type,
  );

  return (
    <div className="flex h-[calc(100vh-10rem)] w-full items-center justify-center">
      {isAttachmentPdf && (
        <PdfPreview className="size-full px-8" src={attachment.url} />
      )}
      {isAttachmentVideo && !isAttachmentVoiceMessage && (
        <HtmlVideoPlayer
          src={attachment.url}
          type={attachment.content_type}
          className="max-h-full max-w-full object-contain"
          controlsList="play"
          autoPlay={isActive}
          poster={attachment.image_variants?.thumbnail}
        />
      )}
      {isAttachmentImage && (
        <>
          <img
            loading="eager"
            alt=""
            className={classNames("max-h-full max-w-full object-contain", {
              hidden: !isImageLoaded,
            })}
            src={attachment.url}
            onLoad={() => setIsImageLoaded(true)}
            onError={() => setIsImageLoaded(true)}
          />
          {!isImageLoaded && <Loader center />}
        </>
      )}
    </div>
  );
};
